import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
const defaultOptions = {};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type AdministrateInstructorInput = {
  allowChildren?: Maybe<Scalars['Boolean']>;
  billingAddress?: Maybe<Scalars['String']>;
  billingFullName?: Maybe<Scalars['String']>;
  billingId?: Maybe<Scalars['String']>;
  billingVATNumber?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
  contractType?: Maybe<InstructorContractType>;
  currentPayRange?: Maybe<PayRange>;
  hourlyWage?: Maybe<Scalars['Float']>;
  ibanNumber?: Maybe<Scalars['String']>;
  minNumberOfHours?: Maybe<Scalars['Float']>;
  spokenLanguages?: Maybe<Array<Scalars['String']>>;
  sportType?: Maybe<Array<Scalars['String']>>;
  targetedLevel?: Maybe<Array<Scalars['String']>>;
};

export type AvailableDay = {
  __typename?: 'AvailableDay';
  date: Scalars['String'];
  slot?: Maybe<DaySlot>;
};

export type AvailableInstructor = {
  __typename?: 'AvailableInstructor';
  availability: InstructorAvailability;
  instructor: User;
  price: Scalars['Float'];
};

export type AvailableInstructorWithoutPrice = {
  __typename?: 'AvailableInstructorWithoutPrice';
  availability: InstructorAvailability;
  instructor: User;
};

export type BookLessonsAndBookingResponse = {
  __typename?: 'BookLessonsAndBookingResponse';
  booking: Booking;
  instructor: User;
  lessons: Array<Lesson>;
  rejectedDates: Array<BookinDateType>;
  totalPrice: Scalars['Float'];
};

export type BookinDateType = {
  __typename?: 'BookinDateType';
  date: Scalars['String'];
  duration: Scalars['Int'];
  startTime: Scalars['String'];
};

export type Booking = {
  __typename?: 'Booking';
  ETPricePerLesson: Scalars['Float'];
  ETTotalIncrementPerHour?: Maybe<Scalars['Float']>;
  VATPricePerLesson: Scalars['Float'];
  VATTotalIncrementPerHour?: Maybe<Scalars['Float']>;
  client: User;
  clientUuid: Scalars['String'];
  createdAt: Scalars['DateTime'];
  currencyCode: Scalars['String'];
  deletedAt: Scalars['DateTime'];
  discount?: Maybe<Discount>;
  discountAmount?: Maybe<Scalars['Float']>;
  instructor?: Maybe<User>;
  instructorUuid?: Maybe<Scalars['String']>;
  invoices?: Maybe<Array<Invoice>>;
  lessons?: Maybe<Array<Lesson>>;
  numberOfAdults: Scalars['Int'];
  numberOfChildren: Scalars['Int'];
  order: Order;
  rentalOrder?: Maybe<RentalOrder>;
  resort?: Maybe<Resort>;
  resortUuid?: Maybe<Scalars['String']>;
  sport: Scalars['String'];
  status: Scalars['String'];
  /** Full Excluded Taxes Price (Rental + Lessons - discount) */
  totalETPrice: Scalars['Float'];
  totalETPriceWithoutDiscount?: Maybe<Scalars['Float']>;
  /** Lessons Excluded Taxes Price  */
  totalLessonsETPrice?: Maybe<Scalars['Float']>;
  /** Lessons VAT Price */
  totalLessonsVATPrice?: Maybe<Scalars['Float']>;
  totalRentingETPrice?: Maybe<Scalars['Float']>;
  totalRentingVATPrice?: Maybe<Scalars['Float']>;
  /** Full VAT Price (RentalVAT + LessonsVAT - discount) */
  totalVATPrice: Scalars['Float'];
  totalVATPriceWithoutDiscount?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['String'];
};

export type BookingDate = {
  date: Scalars['String'];
  duration: Scalars['Int'];
  startTime: Scalars['String'];
};

export type BookingInputData = {
  bookingDates: Array<BookingDate>;
  discount?: Maybe<Scalars['Float']>;
  instructorUuid: Scalars['String'];
  level: Scalars['String'];
  numberOfAdults: Scalars['Int'];
  numberOfChildren: Scalars['Int'];
  resortUuid: Scalars['String'];
  sportType: Scalars['String'];
};

export type Camp = {
  __typename?: 'Camp';
  createdAt: Scalars['DateTime'];
  deletedAt: Scalars['DateTime'];
  name: Scalars['String'];
  packages: Array<CampPackage>;
  resort: Resort;
  resortUuid: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['String'];
};

export type CampOrder = {
  __typename?: 'CampOrder';
  ETPrice?: Maybe<Scalars['Float']>;
  VATPrice?: Maybe<Scalars['Float']>;
  campPackages: Array<CampPackage>;
  clientUuid: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt: Scalars['DateTime'];
  paypalOrderId?: Maybe<Scalars['String']>;
  selection: Array<PackageSelection>;
  status: Scalars['String'];
  stripeIntentPaymentId?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['String'];
};

export type CampPackage = {
  __typename?: 'CampPackage';
  ETPrice: Scalars['Float'];
  VATPrice: Scalars['Float'];
  camp: Camp;
  campUuid: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt: Scalars['DateTime'];
  description: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  picture: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['String'];
};

export type Client = {
  __typename?: 'Client';
  createdAt: Scalars['DateTime'];
  deletedAt: Scalars['DateTime'];
  level: Scalars['String'];
  sportType: Array<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['String'];
};

export type ClientInput = {
  level: Scalars['String'];
  sportType: Array<Scalars['String']>;
};

export type ClientUpdateNameInput = {
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type Country = {
  __typename?: 'Country';
  createdAt: Scalars['DateTime'];
  deletedAt: Scalars['DateTime'];
  name: Scalars['String'];
  rentalCompany?: Maybe<Array<RentalCompany>>;
  resorts?: Maybe<Array<Resort>>;
  stores?: Maybe<Array<RentalStore>>;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['String'];
  vat: Scalars['Float'];
};

export type DashboardDataResponse = {
  __typename?: 'DashboardDataResponse';
  bookings: Scalars['Float'];
  clients: Scalars['Float'];
  instructors: Scalars['Float'];
  resorts: Scalars['Float'];
  reviews: Scalars['Float'];
};

export type DateSlot = {
  __typename?: 'DateSlot';
  endDate: Scalars['String'];
  startDate: Scalars['String'];
};

export type DaySlot = {
  __typename?: 'DaySlot';
  endTime: Scalars['String'];
  startTime: Scalars['String'];
};

export type DaySlotInput = {
  endTime: Scalars['String'];
  startTime: Scalars['String'];
};

export type Device = {
  __typename?: 'Device';
  createdAt: Scalars['DateTime'];
  deletedAt: Scalars['DateTime'];
  deviceId: Scalars['String'];
  isActive: Scalars['Boolean'];
  notificationToken: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user: User;
  userUuid: Scalars['String'];
  uuid: Scalars['String'];
};

export type DeviceInput = {
  deviceId: Scalars['String'];
  pushToken: Scalars['String'];
};

export type DisableDay = {
  __typename?: 'DisableDay';
  date: Scalars['String'];
  slots: Array<DaySlot>;
};

export type Discount = {
  __typename?: 'Discount';
  bookings?: Maybe<Array<Booking>>;
  code: Scalars['String'];
  createdAt: Scalars['DateTime'];
  currentLimitNumber?: Maybe<Scalars['Float']>;
  deletedAt: Scalars['DateTime'];
  functionName: Scalars['String'];
  hasLimit?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['DateTime'];
  users?: Maybe<Array<User>>;
  uuid: Scalars['String'];
};

export type FieldError = {
  __typename?: 'FieldError';
  field?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type Instructor = {
  __typename?: 'Instructor';
  allowChildren: Scalars['Boolean'];
  billingAddress?: Maybe<Scalars['String']>;
  billingFullName?: Maybe<Scalars['String']>;
  billingId?: Maybe<Scalars['String']>;
  billingVATNumber?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
  contractType: Scalars['String'];
  createdAt: Scalars['DateTime'];
  currentMonthIncome: Scalars['Float'];
  currentNumberOfHours: Scalars['Float'];
  currentNumberOfLessons: Scalars['Float'];
  currentPayRange: Scalars['String'];
  currentWeekIncome: Scalars['Float'];
  deletedAt: Scalars['DateTime'];
  disableDays?: Maybe<Array<DisableDay>>;
  hourlyWage: Scalars['Float'];
  ibanNumber?: Maybe<Scalars['String']>;
  lastLessonDate: Scalars['DateTime'];
  lastPaymentDate: Scalars['DateTime'];
  minNumberOfHours: Scalars['Float'];
  nextPaymentDate: Scalars['DateTime'];
  rating: Scalars['Float'];
  spokenLanguages?: Maybe<Array<Scalars['String']>>;
  sportType?: Maybe<Array<Scalars['String']>>;
  targetedLevel: Array<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['String'];
};

export type InstructorAvailability = {
  __typename?: 'InstructorAvailability';
  availableDays: Array<AvailableDay>;
  points: Scalars['Float'];
};

export enum InstructorContractType {
  Freelancer = 'FREELANCER',
  Full = 'FULL',
  NotDefined = 'NOT_DEFINED'
}

export type InstructorDataResponse = {
  __typename?: 'InstructorDataResponse';
  rating: Scalars['Float'];
  totalHours: Scalars['Float'];
  totalLessons: Scalars['Float'];
};

export type InstructorInput = {
  bio?: Maybe<Scalars['String']>;
  minNumberOfHours?: Maybe<Scalars['Int']>;
  sportType?: Maybe<Array<Scalars['String']>>;
  targetedLevel?: Maybe<Array<Scalars['String']>>;
};

export type InstructorResort = {
  __typename?: 'InstructorResort';
  createdAt: Scalars['DateTime'];
  deletedAt: Scalars['DateTime'];
  instructor: User;
  instructorUuid: Scalars['String'];
  isActive: Scalars['Boolean'];
  resort: Resort;
  resortUuid: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['String'];
};

export type InstructorSalaryInformationResponse = {
  __typename?: 'InstructorSalaryInformationResponse';
  amountDue?: Maybe<Scalars['Float']>;
  nextTransferDueDate?: Maybe<Scalars['String']>;
};

export type InstructorsSearchQueryInput = {
  bookingDates: Array<BookingDate>;
  language: Scalars['String'];
  level: Scalars['String'];
  numberOfAdults: Scalars['Int'];
  numberOfChildren: Scalars['Int'];
  resortUuid: Scalars['String'];
  sportType: Scalars['String'];
};

export type Invoice = {
  __typename?: 'Invoice';
  booking: Booking;
  client: User;
  createdAt: Scalars['DateTime'];
  day: Scalars['String'];
  deletedAt: Scalars['DateTime'];
  instructor?: Maybe<User>;
  invoiceNumber: Scalars['String'];
  month: Scalars['String'];
  provider: Scalars['String'];
  providerId: Scalars['String'];
  store?: Maybe<RentalStore>;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['String'];
  year: Scalars['String'];
};

export type Language = {
  __typename?: 'Language';
  createdAt: Scalars['DateTime'];
  deletedAt: Scalars['DateTime'];
  isoCode: Scalars['String'];
  /** Translation key */
  key: Scalars['String'];
  long: Scalars['String'];
  short: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['String'];
};

export type LanguageInput = {
  isoCode?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['String']>;
  short?: Maybe<Scalars['String']>;
};

export type Lesson = {
  __typename?: 'Lesson';
  booking: Booking;
  bookingUuid?: Maybe<Scalars['String']>;
  client: User;
  clientUuid: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt: Scalars['DateTime'];
  duration: Scalars['Int'];
  endTime: Scalars['String'];
  instructor: User;
  instructorUuid: Scalars['String'];
  lessonDate: Scalars['String'];
  level: Scalars['String'];
  meetingPoint: Location;
  numberOfAdults: Scalars['Int'];
  numberOfChildren: Scalars['Int'];
  order: Order;
  price: Scalars['Float'];
  resort: Resort;
  resortUuid: Scalars['String'];
  sport: Scalars['String'];
  startTime: Scalars['String'];
  status: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['String'];
};

export type LessonDetails = {
  __typename?: 'LessonDetails';
  amount: Scalars['Float'];
  currency: Scalars['String'];
  date: Scalars['String'];
  totalHour: Scalars['Float'];
};

export type LessonInput = {
  duration?: Maybe<Scalars['Int']>;
  lessonDate?: Maybe<Scalars['String']>;
  sport?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type LessonWithFullPrice = {
  __typename?: 'LessonWithFullPrice';
  booking: Booking;
  bookingUuid?: Maybe<Scalars['String']>;
  client: User;
  clientUuid: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt: Scalars['DateTime'];
  duration: Scalars['Int'];
  endTime: Scalars['String'];
  fullPrice: Scalars['Float'];
  instructor: User;
  instructorUuid: Scalars['String'];
  lessonDate: Scalars['String'];
  level: Scalars['String'];
  meetingPoint: Location;
  numberOfAdults: Scalars['Int'];
  numberOfChildren: Scalars['Int'];
  order: Order;
  price: Scalars['Float'];
  resort: Resort;
  resortUuid: Scalars['String'];
  sport: Scalars['String'];
  startTime: Scalars['String'];
  status: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['String'];
};

export type Location = {
  __typename?: 'Location';
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
};

export type LocationInput = {
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
};

export type MoneyAmount = {
  __typename?: 'MoneyAmount';
  amount: Scalars['Float'];
  currency?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addInstructorResort: Scalars['Boolean'];
  adminAddInstructorResort: Scalars['Boolean'];
  adminChangeInstructorForALesson: UpdatedLessonResponse;
  adminRemoveInstructorResort: Scalars['Boolean'];
  adminToggleInstructorResort: Scalars['Boolean'];
  administrateInstructor: Instructor;
  applyDiscount: Booking;
  approveReview: Review;
  bookLessons: BookLessonsAndBookingResponse;
  cancelLesson: Lesson;
  cancelRentalOrder: Scalars['Boolean'];
  capturePaypalOrder: Scalars['Boolean'];
  captureStripePayment: Scalars['Boolean'];
  createCampOrder: CampOrder;
  createLanguage: Language;
  createPaypalOrder: PaypalOrderResponse;
  createRentalOrder: RentalOrder;
  createResort: Resort;
  createReview: Review;
  createStripeOrder: Scalars['String'];
  deleteBooking: Scalars['Boolean'];
  deleteResort: Scalars['Boolean'];
  loginAdmin: UserAuthResponse;
  loginClient: UserAuthResponse;
  loginInstructor: UserAuthResponse;
  removeDiscount: Booking;
  removeInstructorResort: Scalars['Boolean'];
  removeLanguage: Scalars['Boolean'];
  revokeReview: Review;
  saveDevice: Device;
  sendTestNotification: Scalars['Boolean'];
  toggleDisableDay: Scalars['Boolean'];
  toggleInstructorResort: Scalars['Boolean'];
  updateBooking: BookLessonsAndBookingResponse;
  updateCampOrder: CampOrder;
  updateClient: Client;
  updateClientName: User;
  updateDiscount: Booking;
  updateInstructor: Instructor;
  updateInstructorLanguages: Array<Scalars['String']>;
  updateLanguage: Language;
  updateLesson: Lesson;
  updateNotificationsEnabled: Scalars['Boolean'];
  updateResort: Resort;
  updateSchedule: ScheduleTemplate;
  updateUserProfile: UserProfile;
  uploadProfilePicture: Scalars['String'];
};

export type MutationAddInstructorResortArgs = {
  resortUuid: Scalars['String'];
};

export type MutationAdminAddInstructorResortArgs = {
  resortUuid: Scalars['String'];
  userUuid: Scalars['String'];
};

export type MutationAdminChangeInstructorForALessonArgs = {
  bookingInputData: UpdateLessonInputData;
  instructorUuid: Scalars['String'];
  lessonUuid: Scalars['String'];
};

export type MutationAdminRemoveInstructorResortArgs = {
  resortUuid: Scalars['String'];
  userUuid: Scalars['String'];
};

export type MutationAdminToggleInstructorResortArgs = {
  isActive: Scalars['Boolean'];
  resortUuid: Scalars['String'];
  userUuid: Scalars['String'];
};

export type MutationAdministrateInstructorArgs = {
  instructorData: AdministrateInstructorInput;
  instructorUuid: Scalars['String'];
};

export type MutationApplyDiscountArgs = {
  bookingUuid: Scalars['String'];
  discountCode: Scalars['String'];
};

export type MutationApproveReviewArgs = {
  reviewUuid: Scalars['String'];
};

export type MutationBookLessonsArgs = {
  bookingInputData: BookingInputData;
};

export type MutationCancelLessonArgs = {
  lessonUuid: Scalars['String'];
};

export type MutationCancelRentalOrderArgs = {
  rentalOrderUuid: Scalars['String'];
};

export type MutationCapturePaypalOrderArgs = {
  orderId: Scalars['String'];
};

export type MutationCaptureStripePaymentArgs = {
  bookingUuid: Scalars['String'];
};

export type MutationCreateCampOrderArgs = {
  packages: Array<PackageSelectionInput>;
};

export type MutationCreateLanguageArgs = {
  languageInput: LanguageInput;
};

export type MutationCreatePaypalOrderArgs = {
  bookingUuid: Scalars['String'];
};

export type MutationCreateRentalOrderArgs = {
  rentalOrderData: RentalOrderInput;
};

export type MutationCreateResortArgs = {
  resortData: ResortInput;
};

export type MutationCreateReviewArgs = {
  bookingUuid: Scalars['String'];
  content: Scalars['String'];
  rating: Scalars['Float'];
  userUuid: Scalars['String'];
};

export type MutationCreateStripeOrderArgs = {
  bookingUuid: Scalars['String'];
};

export type MutationDeleteBookingArgs = {
  bookingUuid: Scalars['String'];
};

export type MutationDeleteResortArgs = {
  resortUuid: Scalars['String'];
};

export type MutationLoginAdminArgs = {
  idToken: Scalars['String'];
};

export type MutationLoginClientArgs = {
  idToken: Scalars['String'];
};

export type MutationLoginInstructorArgs = {
  idToken: Scalars['String'];
};

export type MutationRemoveDiscountArgs = {
  bookingUuid: Scalars['String'];
};

export type MutationRemoveInstructorResortArgs = {
  resortUuid: Scalars['String'];
};

export type MutationRemoveLanguageArgs = {
  languageUuid: Scalars['String'];
};

export type MutationRevokeReviewArgs = {
  reviewUuid: Scalars['String'];
};

export type MutationSaveDeviceArgs = {
  deviceInfo: DeviceInput;
};

export type MutationToggleDisableDayArgs = {
  date: Scalars['String'];
  isDisable: Scalars['Boolean'];
  slots?: Maybe<Array<DaySlotInput>>;
};

export type MutationToggleInstructorResortArgs = {
  isActive: Scalars['Boolean'];
  resortUuid: Scalars['String'];
};

export type MutationUpdateBookingArgs = {
  bookingInputData: BookingInputData;
  bookingUuid: Scalars['String'];
};

export type MutationUpdateCampOrderArgs = {
  orderUuid: Scalars['String'];
  packages: Array<PackageSelectionInput>;
};

export type MutationUpdateClientArgs = {
  clientData: ClientInput;
};

export type MutationUpdateClientNameArgs = {
  input: ClientUpdateNameInput;
};

export type MutationUpdateDiscountArgs = {
  bookingUuid: Scalars['String'];
  discountCode: Scalars['String'];
};

export type MutationUpdateInstructorArgs = {
  instructorData: InstructorInput;
};

export type MutationUpdateInstructorLanguagesArgs = {
  languages: Array<Scalars['String']>;
};

export type MutationUpdateLanguageArgs = {
  languageInput: LanguageInput;
  languageUuid: Scalars['String'];
};

export type MutationUpdateLessonArgs = {
  lessonData: LessonInput;
  lessonUuid: Scalars['String'];
};

export type MutationUpdateNotificationsEnabledArgs = {
  newState: Scalars['Boolean'];
};

export type MutationUpdateResortArgs = {
  resortData: ResortInput;
  resortUuid: Scalars['String'];
};

export type MutationUpdateScheduleArgs = {
  scheduleInput: Array<ScheduleDayInput>;
};

export type MutationUpdateUserProfileArgs = {
  profileData: ProfileInput;
};

export type MutationUploadProfilePictureArgs = {
  file: Scalars['Upload'];
};

export type Order = {
  __typename?: 'Order';
  ETPrice: Scalars['Float'];
  VATPrice: Scalars['Float'];
  clientUuid: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt: Scalars['DateTime'];
  instructorUuid?: Maybe<Scalars['String']>;
  lessons?: Maybe<Array<Lesson>>;
  paypalOrderId?: Maybe<Scalars['String']>;
  pricePerLesson: Scalars['Float'];
  status: Scalars['String'];
  stripeIntentPaymentId?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['String'];
};

export type PackageSelection = {
  __typename?: 'PackageSelection';
  packageUuid: Scalars['String'];
  quantity?: Maybe<Scalars['Float']>;
};

export type PackageSelectionInput = {
  packageUuid: Scalars['String'];
  quantity?: Maybe<Scalars['Float']>;
};

export enum PayRange {
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export type PaypalOrderResponse = {
  __typename?: 'PaypalOrderResponse';
  approveLink: Scalars['String'];
  orderId: Scalars['String'];
};

export type ProductDateRange = {
  endDate: Scalars['String'];
  startDate: Scalars['String'];
};

export type ProductInput = {
  /** Contains all UUIDs of activated options */
  activatedOptions?: Maybe<Array<Scalars['String']>>;
  dates: Array<ProductDateRange>;
  quantity: Scalars['Float'];
  uuid: Scalars['String'];
};

export type ProfileInput = {
  address?: Maybe<Scalars['String']>;
  age?: Maybe<Scalars['Int']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  adminGetAvailableInstructorForALesson: Array<AvailableInstructorWithoutPrice>;
  adminGetDashboardData: DashboardDataResponse;
  adminGetInstructorResorts: Array<InstructorResort>;
  adminGetInstructorSchedule: ScheduleTemplate;
  getAllReviews: Array<Review>;
  getAvailableInstructors: Array<AvailableInstructor>;
  getAvailableResorts: Array<Resort>;
  getBooking: Booking;
  getBookingReceipt: Scalars['String'];
  getBookings: Array<Booking>;
  getClient: User;
  getClientBooking: Booking;
  getClientLessons: Array<LessonWithFullPrice>;
  getClientRentalOrder: RentalOrder;
  getClientRentalOrders: Array<RentalOrder>;
  getClients: Array<User>;
  getCustomTokenForClient: Scalars['String'];
  getDefaultPackagesList: Array<CampPackage>;
  getFirebaseId: Scalars['String'];
  getInstructorBookingReceipts: Scalars['String'];
  getInstructorData: InstructorDataResponse;
  getInstructorLessons: Array<Lesson>;
  getInstructorProfile: User;
  getInstructorResort: Array<InstructorResort>;
  getInstructorReviews: Array<Review>;
  getInstructorSalaryInformation: InstructorSalaryInformationResponse;
  getInstructors: Array<User>;
  getLanguage: Language;
  getLanguages: Array<Language>;
  getLesson: Lesson;
  getMe: User;
  getOneReview: Review;
  getOrder: Order;
  getProductsByStore: Array<RentalProductToRentalStoreEntity>;
  getRandomReviews: Array<Review>;
  getResort: Resort;
  getResorts: Array<Resort>;
  getSchedule: ScheduleTemplate;
  getStoresAndProductsByResort: Array<RentalStore>;
  getStoresAndSortedProductsByResort: Array<StoreWithSortedProductsResponse>;
  getUnratedBooking: Array<Booking>;
  getUserRating: RatingResponse;
  getUserReviews: Array<Review>;
  getUserWithFirebaseId: User;
  getWallet: WalletTemplate;
};

export type QueryAdminGetAvailableInstructorForALessonArgs = {
  lessonUuid: Scalars['String'];
};

export type QueryAdminGetInstructorResortsArgs = {
  userUuid: Scalars['String'];
};

export type QueryAdminGetInstructorScheduleArgs = {
  instructorUuid: Scalars['String'];
};

export type QueryGetAllReviewsArgs = {
  skip?: Maybe<Scalars['Float']>;
  take?: Maybe<Scalars['Float']>;
};

export type QueryGetAvailableInstructorsArgs = {
  queryInput: InstructorsSearchQueryInput;
};

export type QueryGetBookingArgs = {
  bookingUuid: Scalars['String'];
};

export type QueryGetBookingReceiptArgs = {
  bookingUuid: Scalars['String'];
};

export type QueryGetBookingsArgs = {
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
};

export type QueryGetClientArgs = {
  userUuid: Scalars['String'];
};

export type QueryGetClientBookingArgs = {
  bookingUuid: Scalars['String'];
};

export type QueryGetClientLessonsArgs = {
  userUuid?: Maybe<Scalars['String']>;
};

export type QueryGetClientRentalOrderArgs = {
  rentalOrderUuid: Scalars['String'];
};

export type QueryGetClientsArgs = {
  searchField?: Maybe<Scalars['String']>;
  skip?: Maybe<Scalars['Float']>;
  take?: Maybe<Scalars['Float']>;
};

export type QueryGetCustomTokenForClientArgs = {
  idToken: Scalars['String'];
};

export type QueryGetFirebaseIdArgs = {
  uuid: Scalars['String'];
};

export type QueryGetInstructorBookingReceiptsArgs = {
  endDate?: Maybe<Scalars['DateTime']>;
  startDate?: Maybe<Scalars['DateTime']>;
  userUuid: Scalars['String'];
};

export type QueryGetInstructorDataArgs = {
  userUuid: Scalars['String'];
};

export type QueryGetInstructorLessonsArgs = {
  endDate?: Maybe<Scalars['DateTime']>;
  instructorUuid?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
};

export type QueryGetInstructorProfileArgs = {
  instructorUuid: Scalars['String'];
};

export type QueryGetInstructorSalaryInformationArgs = {
  instructorUuid: Scalars['String'];
};

export type QueryGetInstructorsArgs = {
  searchField?: Maybe<Scalars['String']>;
  skip?: Maybe<Scalars['Float']>;
  take?: Maybe<Scalars['Float']>;
};

export type QueryGetLanguageArgs = {
  languageUuid: Scalars['String'];
};

export type QueryGetLessonArgs = {
  lessonUuid: Scalars['String'];
};

export type QueryGetOneReviewArgs = {
  reviewUuid: Scalars['String'];
};

export type QueryGetOrderArgs = {
  bookingUuid?: Maybe<Scalars['String']>;
  orderUuid?: Maybe<Scalars['String']>;
};

export type QueryGetProductsByStoreArgs = {
  storeUuid: Scalars['String'];
};

export type QueryGetRandomReviewsArgs = {
  number: Scalars['Float'];
};

export type QueryGetResortArgs = {
  resortUuid: Scalars['String'];
};

export type QueryGetResortsArgs = {
  skip?: Maybe<Scalars['Float']>;
  take?: Maybe<Scalars['Float']>;
};

export type QueryGetStoresAndProductsByResortArgs = {
  resortUuid: Scalars['String'];
};

export type QueryGetStoresAndSortedProductsByResortArgs = {
  resortUuid: Scalars['String'];
};

export type QueryGetUserRatingArgs = {
  userUuid: Scalars['String'];
};

export type QueryGetUserReviewsArgs = {
  userUuid: Scalars['String'];
};

export type QueryGetUserWithFirebaseIdArgs = {
  firebaseId: Scalars['String'];
};

export type QueryGetWalletArgs = {
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
};

export type RatingResponse = {
  __typename?: 'RatingResponse';
  rating: Scalars['Float'];
  totalReviews: Scalars['Float'];
};

export type RentalCompany = {
  __typename?: 'RentalCompany';
  address: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt: Scalars['DateTime'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['String'];
  zipcode: Scalars['String'];
};

export type RentalOrder = {
  __typename?: 'RentalOrder';
  booking?: Maybe<Booking>;
  createdAt: Scalars['DateTime'];
  deletedAt: Scalars['DateTime'];
  endDate: Scalars['String'];
  productToOrders: Array<RentalProductToRentalOrderEntity>;
  startDate: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  store: RentalStore;
  totalETPrice: Scalars['Float'];
  totalVATPrice: Scalars['Float'];
  updatedAt: Scalars['DateTime'];
  user: User;
  uuid: Scalars['String'];
};

export type RentalOrderInput = {
  bookingUuid?: Maybe<Scalars['String']>;
  products: Array<ProductInput>;
  storeUuid: Scalars['String'];
};

export type RentalProduct = {
  __typename?: 'RentalProduct';
  category: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  options: Array<RentalProductOption>;
  picture?: Maybe<Scalars['String']>;
  productToOrders: Array<RentalProductToRentalOrderEntity>;
  productToStores: Array<RentalProductToRentalStoreEntity>;
  status: Scalars['String'];
  type: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['String'];
};

export type RentalProductOption = {
  __typename?: 'RentalProductOption';
  createdAt: Scalars['DateTime'];
  deletedAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  picture?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  product: RentalProduct;
  productToOrders: RentalProductToRentalOrderEntity;
  productToStore: RentalProductToRentalStoreEntity;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['String'];
};

export type RentalProductToRentalOrderEntity = {
  __typename?: 'RentalProductToRentalOrderEntity';
  activatedOptions?: Maybe<Array<RentalProductOption>>;
  createdAt: Scalars['DateTime'];
  dates: Array<DateSlot>;
  deletedAt: Scalars['DateTime'];
  order: RentalOrder;
  orderUuid: Scalars['String'];
  pricePerItem?: Maybe<Scalars['Float']>;
  product: RentalProduct;
  productUuid: Scalars['String'];
  quantity: Scalars['Int'];
  totalPrice?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['String'];
};

export type RentalProductToRentalStoreEntity = {
  __typename?: 'RentalProductToRentalStoreEntity';
  createdAt: Scalars['DateTime'];
  currentQuantity: Scalars['Int'];
  deletedAt: Scalars['DateTime'];
  maxQuantity: Scalars['Int'];
  options: Array<RentalProductOption>;
  price?: Maybe<Scalars['Float']>;
  product: RentalProduct;
  productUuid: Scalars['String'];
  store: RentalStore;
  storeUuid: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['String'];
};

export type RentalStore = {
  __typename?: 'RentalStore';
  address: Scalars['String'];
  billingId?: Maybe<Scalars['String']>;
  billingVATNumber?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company: RentalCompany;
  country: Country;
  createdAt: Scalars['DateTime'];
  deletedAt: Scalars['DateTime'];
  googleSheetFile?: Maybe<Scalars['String']>;
  googleSheetId?: Maybe<Scalars['String']>;
  invoices?: Maybe<Array<Invoice>>;
  invoicesFromVimbu?: Maybe<Array<Invoice>>;
  location?: Maybe<Location>;
  name: Scalars['String'];
  orders: Array<RentalOrder>;
  phone?: Maybe<Scalars['String']>;
  productToStores?: Maybe<Array<RentalProductToRentalStoreEntity>>;
  resort: Resort;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['String'];
  zipcode: Scalars['String'];
};

export type Resort = {
  __typename?: 'Resort';
  camps?: Maybe<Array<Camp>>;
  country?: Maybe<Country>;
  createdAt: Scalars['DateTime'];
  deletedAt: Scalars['DateTime'];
  instructorResorts?: Maybe<Array<InstructorResort>>;
  lessons?: Maybe<Array<Lesson>>;
  location?: Maybe<Location>;
  name: Scalars['String'];
  price?: Maybe<Scalars['Float']>;
  rentalStores?: Maybe<Array<RentalStore>>;
  seasonType?: Maybe<SeasonType>;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['String'];
};

export type ResortInput = {
  coordinates?: Maybe<LocationInput>;
  countryUuid: Scalars['String'];
  name: Scalars['String'];
  price: Scalars['Float'];
};

export type Review = {
  __typename?: 'Review';
  content: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt: Scalars['DateTime'];
  rating: Scalars['Float'];
  receiver: User;
  reviewer: User;
  status: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['String'];
};

export type ScheduleDay = {
  __typename?: 'ScheduleDay';
  day: Scalars['String'];
  slots: Array<DaySlot>;
};

export type ScheduleDayInput = {
  day: Scalars['String'];
  slots: Array<DaySlotInput>;
};

export type ScheduleTemplate = {
  __typename?: 'ScheduleTemplate';
  activationDate?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt: Scalars['DateTime'];
  endDate?: Maybe<Scalars['String']>;
  instructorUuid: Scalars['String'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  schedule: Array<ScheduleDay>;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['String'];
};

export type SeasonType = {
  __typename?: 'SeasonType';
  createdAt: Scalars['DateTime'];
  deletedAt: Scalars['DateTime'];
  multiplier: Scalars['Float'];
  name: Scalars['String'];
  resorts?: Maybe<Array<Resort>>;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['String'];
};

export type SortedProductResponse = {
  __typename?: 'SortedProductResponse';
  ADULT?: Maybe<Array<RentalProductToRentalStoreEntity>>;
  CHILDREN?: Maybe<Array<RentalProductToRentalStoreEntity>>;
  OTHER?: Maybe<Array<RentalProductToRentalStoreEntity>>;
};

export type StoreWithSortedProductsResponse = {
  __typename?: 'StoreWithSortedProductsResponse';
  address: Scalars['String'];
  country: Country;
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  products: SortedProductResponse;
  uuid: Scalars['String'];
  zipcode: Scalars['String'];
};

export type UpdateLessonInputData = {
  lessonDate: Scalars['String'];
  lessonDuration: Scalars['Float'];
  lessonStartTime: Scalars['String'];
};

export type UpdatedLessonResponse = {
  __typename?: 'UpdatedLessonResponse';
  newLesson: Lesson;
  oldLesson?: Maybe<Lesson>;
};

export type User = {
  __typename?: 'User';
  client?: Maybe<Client>;
  clientInvoices?: Maybe<Array<Invoice>>;
  createdAt: Scalars['DateTime'];
  deletedAt: Scalars['DateTime'];
  devices?: Maybe<Array<Device>>;
  discounts?: Maybe<Array<Discount>>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  instructor?: Maybe<Instructor>;
  instructorInvoices?: Maybe<Array<Invoice>>;
  instructorInvoicesFromVimbu?: Maybe<Array<Invoice>>;
  instructorResorts?: Maybe<Array<InstructorResort>>;
  lastName: Scalars['String'];
  picture?: Maybe<Scalars['String']>;
  profile: UserProfile;
  registrationComplete: Scalars['Boolean'];
  rentalOrders?: Maybe<Array<RentalOrder>>;
  role: Scalars['String'];
  scheduleTemplates?: Maybe<Array<ScheduleTemplate>>;
  takenLessons?: Maybe<Array<Lesson>>;
  teachedLessons?: Maybe<Array<Lesson>>;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['String'];
};

export type UserAuthResponse = {
  __typename?: 'UserAuthResponse';
  error?: Maybe<FieldError>;
  user?: Maybe<User>;
};

export type UserProfile = {
  __typename?: 'UserProfile';
  address?: Maybe<Scalars['String']>;
  age?: Maybe<Scalars['Float']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt: Scalars['DateTime'];
  gender: Scalars['String'];
  language?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['String'];
  zipCode?: Maybe<Scalars['String']>;
};

export type WalletTemplate = {
  __typename?: 'WalletTemplate';
  detail: Array<LessonDetails>;
  totalAmount: MoneyAmount;
  totalHour: Scalars['Float'];
  totalLessons: Scalars['Float'];
};

export type ApplyDiscountMutationVariables = Exact<{
  discountCode: Scalars['String'];
  bookingUuid: Scalars['String'];
}>;

export type ApplyDiscountMutation = {
  __typename?: 'Mutation';
  applyDiscount: {
    __typename?: 'Booking';
    uuid: string;
    VATPricePerLesson: number;
    ETPricePerLesson: number;
    totalETPrice: number;
    totalVATPrice: number;
    VATTotalIncrementPerHour?: number | null | undefined;
    totalETPriceWithoutDiscount?: number | null | undefined;
    totalVATPriceWithoutDiscount?: number | null | undefined;
    totalRentingETPrice?: number | null | undefined;
    totalRentingVATPrice?: number | null | undefined;
    totalLessonsVATPrice?: number | null | undefined;
    totalLessonsETPrice?: number | null | undefined;
    discountAmount?: number | null | undefined;
    discount?: { __typename?: 'Discount'; code: string } | null | undefined;
  };
};

export type BookLessonsMutationVariables = Exact<{
  level: Scalars['String'];
  sportType: Scalars['String'];
  resortUuid: Scalars['String'];
  instructorUuid: Scalars['String'];
  bookingDates: Array<BookingDate> | BookingDate;
  numberOfAdults: Scalars['Int'];
  numberOfChildren: Scalars['Int'];
  discount: Scalars['Float'];
}>;

export type BookLessonsMutation = {
  __typename?: 'Mutation';
  bookLessons: {
    __typename?: 'BookLessonsAndBookingResponse';
    booking: {
      __typename?: 'Booking';
      uuid: string;
      numberOfAdults: number;
      numberOfChildren: number;
      VATPricePerLesson: number;
      ETPricePerLesson: number;
      totalETPrice: number;
      totalVATPrice: number;
      VATTotalIncrementPerHour?: number | null | undefined;
      totalETPriceWithoutDiscount?: number | null | undefined;
      totalVATPriceWithoutDiscount?: number | null | undefined;
      totalRentingETPrice?: number | null | undefined;
      totalRentingVATPrice?: number | null | undefined;
      totalLessonsVATPrice?: number | null | undefined;
      totalLessonsETPrice?: number | null | undefined;
      discountAmount?: number | null | undefined;
      discount?: { __typename?: 'Discount'; code: string } | null | undefined;
      instructor?:
        | {
            __typename?: 'User';
            firstName: string;
            lastName: string;
            email: string;
          }
        | null
        | undefined;
      lessons?:
        | Array<{
            __typename?: 'Lesson';
            lessonDate: string;
            duration: number;
            sport: string;
            startTime: string;
            status: string;
            price: number;
          }>
        | null
        | undefined;
      resort?:
        | {
            __typename?: 'Resort';
            uuid: string;
            name: string;
            price?: number | null | undefined;
          }
        | null
        | undefined;
    };
    rejectedDates: Array<{
      __typename?: 'BookinDateType';
      date: string;
      duration: number;
      startTime: string;
    }>;
  };
};

export type CapturePaypalOrderMutationVariables = Exact<{
  orderId: Scalars['String'];
}>;

export type CapturePaypalOrderMutation = {
  __typename?: 'Mutation';
  capturePaypalOrder: boolean;
};

export type CaptureStripePaymentMutationVariables = Exact<{
  bookingUuid: Scalars['String'];
}>;

export type CaptureStripePaymentMutation = {
  __typename?: 'Mutation';
  captureStripePayment: boolean;
};

export type CreateCampOrderMutationVariables = Exact<{
  packages: Array<PackageSelectionInput> | PackageSelectionInput;
}>;

export type CreateCampOrderMutation = {
  __typename?: 'Mutation';
  createCampOrder: {
    __typename?: 'CampOrder';
    uuid: string;
    clientUuid: string;
    ETPrice?: number | null | undefined;
    VATPrice?: number | null | undefined;
  };
};

export type CreatePaypalOrderMutationVariables = Exact<{
  bookingUuid: Scalars['String'];
}>;

export type CreatePaypalOrderMutation = {
  __typename?: 'Mutation';
  createPaypalOrder: {
    __typename?: 'PaypalOrderResponse';
    orderId: string;
    approveLink: string;
  };
};

export type CreateRentalOrderMutationVariables = Exact<{
  rentalOrderData: RentalOrderInput;
}>;

export type CreateRentalOrderMutation = {
  __typename?: 'Mutation';
  createRentalOrder: {
    __typename?: 'RentalOrder';
    uuid: string;
    totalETPrice: number;
    totalVATPrice: number;
    startDate: string;
    endDate: string;
    status?: string | null | undefined;
    productToOrders: Array<{
      __typename?: 'RentalProductToRentalOrderEntity';
      uuid: string;
      quantity: number;
      totalPrice?: number | null | undefined;
      dates: Array<{
        __typename?: 'DateSlot';
        startDate: string;
        endDate: string;
      }>;
      product: { __typename?: 'RentalProduct'; uuid: string; name: string };
      activatedOptions?:
        | Array<{
            __typename?: 'RentalProductOption';
            uuid: string;
            price?: number | null | undefined;
            name: string;
          }>
        | null
        | undefined;
    }>;
    booking?:
      | {
          __typename?: 'Booking';
          uuid: string;
          numberOfAdults: number;
          numberOfChildren: number;
          VATPricePerLesson: number;
          ETPricePerLesson: number;
          totalETPrice: number;
          totalVATPrice: number;
          VATTotalIncrementPerHour?: number | null | undefined;
          totalETPriceWithoutDiscount?: number | null | undefined;
          totalVATPriceWithoutDiscount?: number | null | undefined;
          totalRentingETPrice?: number | null | undefined;
          totalRentingVATPrice?: number | null | undefined;
          totalLessonsVATPrice?: number | null | undefined;
          totalLessonsETPrice?: number | null | undefined;
          discountAmount?: number | null | undefined;
          discount?:
            | { __typename?: 'Discount'; code: string }
            | null
            | undefined;
        }
      | null
      | undefined;
  };
};

export type CreateReviewMutationVariables = Exact<{
  rating: Scalars['Float'];
  content: Scalars['String'];
  bookingUuid: Scalars['String'];
  userUuid: Scalars['String'];
}>;

export type CreateReviewMutation = {
  __typename?: 'Mutation';
  createReview: {
    __typename?: 'Review';
    uuid: string;
    rating: number;
    content: string;
  };
};

export type CreateStripeOrderMutationVariables = Exact<{
  bookingUuid: Scalars['String'];
}>;

export type CreateStripeOrderMutation = {
  __typename?: 'Mutation';
  createStripeOrder: string;
};

export type DeleteBookingMutationVariables = Exact<{
  bookingUuid: Scalars['String'];
}>;

export type DeleteBookingMutation = {
  __typename?: 'Mutation';
  deleteBooking: boolean;
};

export type LoginClientMutationVariables = Exact<{
  idToken: Scalars['String'];
}>;

export type LoginClientMutation = {
  __typename?: 'Mutation';
  loginClient: {
    __typename?: 'UserAuthResponse';
    error?:
      | {
          __typename?: 'FieldError';
          field?: string | null | undefined;
          message?: string | null | undefined;
        }
      | null
      | undefined;
    user?:
      | {
          __typename?: 'User';
          uuid: string;
          firstName: string;
          lastName: string;
          email: string;
          picture?: string | null | undefined;
          registrationComplete: boolean;
          client?:
            | { __typename?: 'Client'; sportType: Array<string>; level: string }
            | null
            | undefined;
          profile: {
            __typename?: 'UserProfile';
            language?: string | null | undefined;
          };
        }
      | null
      | undefined;
  };
};

export type RemoveDiscountMutationVariables = Exact<{
  bookingUuid: Scalars['String'];
}>;

export type RemoveDiscountMutation = {
  __typename?: 'Mutation';
  removeDiscount: {
    __typename?: 'Booking';
    uuid: string;
    VATPricePerLesson: number;
    ETPricePerLesson: number;
    totalETPrice: number;
    totalVATPrice: number;
    VATTotalIncrementPerHour?: number | null | undefined;
    totalETPriceWithoutDiscount?: number | null | undefined;
    totalVATPriceWithoutDiscount?: number | null | undefined;
    totalRentingETPrice?: number | null | undefined;
    totalRentingVATPrice?: number | null | undefined;
    totalLessonsVATPrice?: number | null | undefined;
    totalLessonsETPrice?: number | null | undefined;
    discountAmount?: number | null | undefined;
    discount?: { __typename?: 'Discount'; code: string } | null | undefined;
  };
};

export type UpdateCampOrderMutationVariables = Exact<{
  packages: Array<PackageSelectionInput> | PackageSelectionInput;
  orderUuid: Scalars['String'];
}>;

export type UpdateCampOrderMutation = {
  __typename?: 'Mutation';
  updateCampOrder: {
    __typename?: 'CampOrder';
    ETPrice?: number | null | undefined;
    VATPrice?: number | null | undefined;
  };
};

export type UpdateClientMutationVariables = Exact<{
  sportType: Array<Scalars['String']> | Scalars['String'];
  level: Scalars['String'];
}>;

export type UpdateClientMutation = {
  __typename?: 'Mutation';
  updateClient: {
    __typename?: 'Client';
    sportType: Array<string>;
    level: string;
  };
};

export type UpdateClientNameMutationVariables = Exact<{
  firstName: Scalars['String'];
  lastName: Scalars['String'];
}>;

export type UpdateClientNameMutation = {
  __typename?: 'Mutation';
  updateClientName: {
    __typename?: 'User';
    firstName: string;
    lastName: string;
  };
};

export type UpdateProfileMutationVariables = Exact<{
  language: Scalars['String'];
}>;

export type UpdateProfileMutation = {
  __typename?: 'Mutation';
  updateUserProfile: {
    __typename?: 'UserProfile';
    language?: string | null | undefined;
  };
};

export type UploadProfilePictureMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;

export type UploadProfilePictureMutation = {
  __typename?: 'Mutation';
  uploadProfilePicture: string;
};

export type GetAvailableResortsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAvailableResortsQuery = {
  __typename?: 'Query';
  getAvailableResorts: Array<{
    __typename?: 'Resort';
    uuid: string;
    name: string;
    price?: number | null | undefined;
  }>;
};

export type GetAvailableInstructorsQueryVariables = Exact<{
  resortUuid: Scalars['String'];
  level: Scalars['String'];
  sportType: Scalars['String'];
  bookingDates: Array<BookingDate> | BookingDate;
  language: Scalars['String'];
  numberOfChildren: Scalars['Int'];
  numberOfAdults: Scalars['Int'];
}>;

export type GetAvailableInstructorsQuery = {
  __typename?: 'Query';
  getAvailableInstructors: Array<{
    __typename?: 'AvailableInstructor';
    price: number;
    instructor: {
      __typename?: 'User';
      uuid: string;
      firstName: string;
      lastName: string;
      email: string;
      picture?: string | null | undefined;
      instructor?:
        | {
            __typename?: 'Instructor';
            bio?: string | null | undefined;
            minNumberOfHours: number;
            rating: number;
            targetedLevel: Array<string>;
            spokenLanguages?: Array<string> | null | undefined;
          }
        | null
        | undefined;
      profile: {
        __typename?: 'UserProfile';
        language?: string | null | undefined;
      };
    };
    availability: {
      __typename?: 'InstructorAvailability';
      points: number;
      availableDays: Array<{
        __typename?: 'AvailableDay';
        date: string;
        slot?:
          | { __typename?: 'DaySlot'; startTime: string; endTime: string }
          | null
          | undefined;
      }>;
    };
  }>;
};

export type GetClientBookingQueryVariables = Exact<{
  bookingUuid: Scalars['String'];
}>;

export type GetClientBookingQuery = {
  __typename?: 'Query';
  getClientBooking: {
    __typename?: 'Booking';
    uuid: string;
    numberOfAdults: number;
    numberOfChildren: number;
    VATPricePerLesson: number;
    ETPricePerLesson: number;
    totalETPrice: number;
    totalVATPrice: number;
    VATTotalIncrementPerHour?: number | null | undefined;
    totalETPriceWithoutDiscount?: number | null | undefined;
    totalVATPriceWithoutDiscount?: number | null | undefined;
    totalRentingETPrice?: number | null | undefined;
    totalRentingVATPrice?: number | null | undefined;
    totalLessonsVATPrice?: number | null | undefined;
    totalLessonsETPrice?: number | null | undefined;
    discountAmount?: number | null | undefined;
    discount?: { __typename?: 'Discount'; code: string } | null | undefined;
    instructor?:
      | {
          __typename?: 'User';
          firstName: string;
          lastName: string;
          email: string;
        }
      | null
      | undefined;
    lessons?:
      | Array<{
          __typename?: 'Lesson';
          lessonDate: string;
          duration: number;
          sport: string;
          startTime: string;
          status: string;
          price: number;
        }>
      | null
      | undefined;
    resort?:
      | {
          __typename?: 'Resort';
          uuid: string;
          name: string;
          price?: number | null | undefined;
        }
      | null
      | undefined;
  };
};

export type GetClientLessonsQueryVariables = Exact<{ [key: string]: never }>;

export type GetClientLessonsQuery = {
  __typename?: 'Query';
  getClientLessons: Array<{
    __typename?: 'LessonWithFullPrice';
    uuid: string;
    lessonDate: string;
    startTime: string;
    duration: number;
    sport: string;
    status: string;
    numberOfAdults: number;
    numberOfChildren: number;
    price: number;
    fullPrice: number;
    instructor: {
      __typename?: 'User';
      uuid: string;
      firstName: string;
      lastName: string;
      email: string;
      picture?: string | null | undefined;
      instructor?:
        | {
            __typename?: 'Instructor';
            bio?: string | null | undefined;
            rating: number;
            targetedLevel: Array<string>;
            spokenLanguages?: Array<string> | null | undefined;
          }
        | null
        | undefined;
      profile: {
        __typename?: 'UserProfile';
        language?: string | null | undefined;
      };
    };
  }>;
};

export type GetClientRentalOrderQueryVariables = Exact<{
  rentalOrderUuid: Scalars['String'];
}>;

export type GetClientRentalOrderQuery = {
  __typename?: 'Query';
  getClientRentalOrder: {
    __typename?: 'RentalOrder';
    uuid: string;
    totalETPrice: number;
    totalVATPrice: number;
    startDate: string;
    endDate: string;
    status?: string | null | undefined;
    productToOrders: Array<{
      __typename?: 'RentalProductToRentalOrderEntity';
      uuid: string;
      quantity: number;
      totalPrice?: number | null | undefined;
      dates: Array<{
        __typename?: 'DateSlot';
        startDate: string;
        endDate: string;
      }>;
      product: { __typename?: 'RentalProduct'; uuid: string; name: string };
      activatedOptions?:
        | Array<{
            __typename?: 'RentalProductOption';
            uuid: string;
            price?: number | null | undefined;
            name: string;
          }>
        | null
        | undefined;
    }>;
    booking?:
      | {
          __typename?: 'Booking';
          uuid: string;
          numberOfAdults: number;
          numberOfChildren: number;
          VATPricePerLesson: number;
          ETPricePerLesson: number;
          totalETPrice: number;
          totalVATPrice: number;
          VATTotalIncrementPerHour?: number | null | undefined;
          totalETPriceWithoutDiscount?: number | null | undefined;
          totalVATPriceWithoutDiscount?: number | null | undefined;
          totalRentingETPrice?: number | null | undefined;
          totalRentingVATPrice?: number | null | undefined;
          totalLessonsVATPrice?: number | null | undefined;
          totalLessonsETPrice?: number | null | undefined;
          discountAmount?: number | null | undefined;
          discount?:
            | { __typename?: 'Discount'; code: string }
            | null
            | undefined;
        }
      | null
      | undefined;
  };
};

export type GetClientRentalOrdersQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetClientRentalOrdersQuery = {
  __typename?: 'Query';
  getClientRentalOrders: Array<{
    __typename?: 'RentalOrder';
    uuid: string;
    totalETPrice: number;
    totalVATPrice: number;
    startDate: string;
    endDate: string;
    status?: string | null | undefined;
    productToOrders: Array<{
      __typename?: 'RentalProductToRentalOrderEntity';
      uuid: string;
      quantity: number;
      totalPrice?: number | null | undefined;
      dates: Array<{
        __typename?: 'DateSlot';
        startDate: string;
        endDate: string;
      }>;
      product: { __typename?: 'RentalProduct'; uuid: string; name: string };
      activatedOptions?:
        | Array<{
            __typename?: 'RentalProductOption';
            uuid: string;
            price?: number | null | undefined;
            name: string;
          }>
        | null
        | undefined;
    }>;
    booking?:
      | {
          __typename?: 'Booking';
          uuid: string;
          numberOfAdults: number;
          numberOfChildren: number;
          VATPricePerLesson: number;
          ETPricePerLesson: number;
          totalETPrice: number;
          totalVATPrice: number;
          VATTotalIncrementPerHour?: number | null | undefined;
          totalETPriceWithoutDiscount?: number | null | undefined;
          totalVATPriceWithoutDiscount?: number | null | undefined;
          totalRentingETPrice?: number | null | undefined;
          totalRentingVATPrice?: number | null | undefined;
          totalLessonsVATPrice?: number | null | undefined;
          totalLessonsETPrice?: number | null | undefined;
          discountAmount?: number | null | undefined;
          discount?:
            | { __typename?: 'Discount'; code: string }
            | null
            | undefined;
        }
      | null
      | undefined;
    store: {
      __typename?: 'RentalStore';
      uuid: string;
      name: string;
      phone?: string | null | undefined;
      address: string;
      resort: { __typename?: 'Resort'; uuid: string; name: string };
    };
  }>;
};

export type GetDefaultPackagesListQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetDefaultPackagesListQuery = {
  __typename?: 'Query';
  getDefaultPackagesList: Array<{
    __typename?: 'CampPackage';
    uuid: string;
    ETPrice: number;
    VATPrice: number;
    name: string;
    description: string;
    picture: string;
  }>;
};

export type GetStoresAndSortedProductsByResortQueryVariables = Exact<{
  resortUuid: Scalars['String'];
}>;

export type GetStoresAndSortedProductsByResortQuery = {
  __typename?: 'Query';
  getStoresAndSortedProductsByResort: Array<{
    __typename?: 'StoreWithSortedProductsResponse';
    uuid: string;
    name: string;
    phone?: string | null | undefined;
    address: string;
    zipcode: string;
    products: {
      __typename?: 'SortedProductResponse';
      ADULT?:
        | Array<{
            __typename?: 'RentalProductToRentalStoreEntity';
            uuid: string;
            productUuid: string;
            currentQuantity: number;
            maxQuantity: number;
            price?: number | null | undefined;
            product: {
              __typename?: 'RentalProduct';
              uuid: string;
              name: string;
              category: string;
              description?: string | null | undefined;
              picture?: string | null | undefined;
              type: string;
            };
            options: Array<{
              __typename?: 'RentalProductOption';
              uuid: string;
              name: string;
              price?: number | null | undefined;
              product: { __typename?: 'RentalProduct'; name: string };
            }>;
          }>
        | null
        | undefined;
      CHILDREN?:
        | Array<{
            __typename?: 'RentalProductToRentalStoreEntity';
            uuid: string;
            productUuid: string;
            currentQuantity: number;
            maxQuantity: number;
            price?: number | null | undefined;
            product: {
              __typename?: 'RentalProduct';
              uuid: string;
              name: string;
              category: string;
              description?: string | null | undefined;
              picture?: string | null | undefined;
              type: string;
            };
            options: Array<{
              __typename?: 'RentalProductOption';
              uuid: string;
              name: string;
              price?: number | null | undefined;
              product: { __typename?: 'RentalProduct'; name: string };
            }>;
          }>
        | null
        | undefined;
      OTHER?:
        | Array<{
            __typename?: 'RentalProductToRentalStoreEntity';
            uuid: string;
            productUuid: string;
            currentQuantity: number;
            maxQuantity: number;
            price?: number | null | undefined;
            product: {
              __typename?: 'RentalProduct';
              uuid: string;
              name: string;
              category: string;
              description?: string | null | undefined;
              picture?: string | null | undefined;
              type: string;
            };
            options: Array<{
              __typename?: 'RentalProductOption';
              uuid: string;
              name: string;
              price?: number | null | undefined;
              product: { __typename?: 'RentalProduct'; name: string };
            }>;
          }>
        | null
        | undefined;
    };
    country: { __typename?: 'Country'; name: string; uuid: string };
  }>;
};

export type GetUnratedBookingQueryVariables = Exact<{ [key: string]: never }>;

export type GetUnratedBookingQuery = {
  __typename?: 'Query';
  getUnratedBooking: Array<{
    __typename?: 'Booking';
    uuid: string;
    instructor?:
      | {
          __typename?: 'User';
          uuid: string;
          firstName: string;
          lastName: string;
          picture?: string | null | undefined;
        }
      | null
      | undefined;
  }>;
};

export type GetUserReviewsQueryVariables = Exact<{
  userUuid: Scalars['String'];
}>;

export type GetUserReviewsQuery = {
  __typename?: 'Query';
  getUserReviews: Array<{
    __typename?: 'Review';
    uuid: string;
    rating: number;
    content: string;
    createdAt: any;
    reviewer: {
      __typename?: 'User';
      uuid: string;
      firstName: string;
      lastName: string;
      picture?: string | null | undefined;
    };
  }>;
};

export const ApplyDiscountDocument = gql`
  mutation ApplyDiscount($discountCode: String!, $bookingUuid: String!) {
    applyDiscount(discountCode: $discountCode, bookingUuid: $bookingUuid) {
      uuid
      VATPricePerLesson
      ETPricePerLesson
      totalETPrice
      totalVATPrice
      VATTotalIncrementPerHour
      totalETPriceWithoutDiscount
      totalVATPriceWithoutDiscount
      totalRentingETPrice
      totalRentingVATPrice
      totalLessonsVATPrice
      totalLessonsETPrice
      discountAmount
      discount {
        code
      }
    }
  }
`;
export type ApplyDiscountMutationFn = Apollo.MutationFunction<
  ApplyDiscountMutation,
  ApplyDiscountMutationVariables
>;

/**
 * __useApplyDiscountMutation__
 *
 * To run a mutation, you first call `useApplyDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyDiscountMutation, { data, loading, error }] = useApplyDiscountMutation({
 *   variables: {
 *      discountCode: // value for 'discountCode'
 *      bookingUuid: // value for 'bookingUuid'
 *   },
 * });
 */
export function useApplyDiscountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApplyDiscountMutation,
    ApplyDiscountMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ApplyDiscountMutation,
    ApplyDiscountMutationVariables
  >(ApplyDiscountDocument, options);
}
export type ApplyDiscountMutationHookResult = ReturnType<
  typeof useApplyDiscountMutation
>;
export type ApplyDiscountMutationResult =
  Apollo.MutationResult<ApplyDiscountMutation>;
export type ApplyDiscountMutationOptions = Apollo.BaseMutationOptions<
  ApplyDiscountMutation,
  ApplyDiscountMutationVariables
>;
export const BookLessonsDocument = gql`
  mutation BookLessons(
    $level: String!
    $sportType: String!
    $resortUuid: String!
    $instructorUuid: String!
    $bookingDates: [BookingDate!]!
    $numberOfAdults: Int!
    $numberOfChildren: Int!
    $discount: Float!
  ) {
    bookLessons(
      bookingInputData: {
        level: $level
        sportType: $sportType
        resortUuid: $resortUuid
        instructorUuid: $instructorUuid
        bookingDates: $bookingDates
        numberOfAdults: $numberOfAdults
        numberOfChildren: $numberOfChildren
        discount: $discount
      }
    ) {
      booking {
        uuid
        numberOfAdults
        numberOfChildren
        VATPricePerLesson
        ETPricePerLesson
        totalETPrice
        totalVATPrice
        VATTotalIncrementPerHour
        totalETPriceWithoutDiscount
        totalVATPriceWithoutDiscount
        totalRentingETPrice
        totalRentingVATPrice
        totalLessonsVATPrice
        totalLessonsETPrice
        discountAmount
        discount {
          code
        }
        instructor {
          firstName
          lastName
          email
        }
        lessons {
          lessonDate
          duration
          sport
          startTime
          status
          price
        }
        numberOfAdults
        numberOfChildren
        resort {
          uuid
          name
          price
        }
      }
      rejectedDates {
        date
        duration
        startTime
      }
    }
  }
`;
export type BookLessonsMutationFn = Apollo.MutationFunction<
  BookLessonsMutation,
  BookLessonsMutationVariables
>;

/**
 * __useBookLessonsMutation__
 *
 * To run a mutation, you first call `useBookLessonsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookLessonsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookLessonsMutation, { data, loading, error }] = useBookLessonsMutation({
 *   variables: {
 *      level: // value for 'level'
 *      sportType: // value for 'sportType'
 *      resortUuid: // value for 'resortUuid'
 *      instructorUuid: // value for 'instructorUuid'
 *      bookingDates: // value for 'bookingDates'
 *      numberOfAdults: // value for 'numberOfAdults'
 *      numberOfChildren: // value for 'numberOfChildren'
 *      discount: // value for 'discount'
 *   },
 * });
 */
export function useBookLessonsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BookLessonsMutation,
    BookLessonsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<BookLessonsMutation, BookLessonsMutationVariables>(
    BookLessonsDocument,
    options
  );
}
export type BookLessonsMutationHookResult = ReturnType<
  typeof useBookLessonsMutation
>;
export type BookLessonsMutationResult =
  Apollo.MutationResult<BookLessonsMutation>;
export type BookLessonsMutationOptions = Apollo.BaseMutationOptions<
  BookLessonsMutation,
  BookLessonsMutationVariables
>;
export const CapturePaypalOrderDocument = gql`
  mutation CapturePaypalOrder($orderId: String!) {
    capturePaypalOrder(orderId: $orderId)
  }
`;
export type CapturePaypalOrderMutationFn = Apollo.MutationFunction<
  CapturePaypalOrderMutation,
  CapturePaypalOrderMutationVariables
>;

/**
 * __useCapturePaypalOrderMutation__
 *
 * To run a mutation, you first call `useCapturePaypalOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCapturePaypalOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [capturePaypalOrderMutation, { data, loading, error }] = useCapturePaypalOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useCapturePaypalOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CapturePaypalOrderMutation,
    CapturePaypalOrderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CapturePaypalOrderMutation,
    CapturePaypalOrderMutationVariables
  >(CapturePaypalOrderDocument, options);
}
export type CapturePaypalOrderMutationHookResult = ReturnType<
  typeof useCapturePaypalOrderMutation
>;
export type CapturePaypalOrderMutationResult =
  Apollo.MutationResult<CapturePaypalOrderMutation>;
export type CapturePaypalOrderMutationOptions = Apollo.BaseMutationOptions<
  CapturePaypalOrderMutation,
  CapturePaypalOrderMutationVariables
>;
export const CaptureStripePaymentDocument = gql`
  mutation CaptureStripePayment($bookingUuid: String!) {
    captureStripePayment(bookingUuid: $bookingUuid)
  }
`;
export type CaptureStripePaymentMutationFn = Apollo.MutationFunction<
  CaptureStripePaymentMutation,
  CaptureStripePaymentMutationVariables
>;

/**
 * __useCaptureStripePaymentMutation__
 *
 * To run a mutation, you first call `useCaptureStripePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCaptureStripePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [captureStripePaymentMutation, { data, loading, error }] = useCaptureStripePaymentMutation({
 *   variables: {
 *      bookingUuid: // value for 'bookingUuid'
 *   },
 * });
 */
export function useCaptureStripePaymentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CaptureStripePaymentMutation,
    CaptureStripePaymentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CaptureStripePaymentMutation,
    CaptureStripePaymentMutationVariables
  >(CaptureStripePaymentDocument, options);
}
export type CaptureStripePaymentMutationHookResult = ReturnType<
  typeof useCaptureStripePaymentMutation
>;
export type CaptureStripePaymentMutationResult =
  Apollo.MutationResult<CaptureStripePaymentMutation>;
export type CaptureStripePaymentMutationOptions = Apollo.BaseMutationOptions<
  CaptureStripePaymentMutation,
  CaptureStripePaymentMutationVariables
>;
export const CreateCampOrderDocument = gql`
  mutation CreateCampOrder($packages: [PackageSelectionInput!]!) {
    createCampOrder(packages: $packages) {
      uuid
      clientUuid
      ETPrice
      VATPrice
    }
  }
`;
export type CreateCampOrderMutationFn = Apollo.MutationFunction<
  CreateCampOrderMutation,
  CreateCampOrderMutationVariables
>;

/**
 * __useCreateCampOrderMutation__
 *
 * To run a mutation, you first call `useCreateCampOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCampOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCampOrderMutation, { data, loading, error }] = useCreateCampOrderMutation({
 *   variables: {
 *      packages: // value for 'packages'
 *   },
 * });
 */
export function useCreateCampOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCampOrderMutation,
    CreateCampOrderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateCampOrderMutation,
    CreateCampOrderMutationVariables
  >(CreateCampOrderDocument, options);
}
export type CreateCampOrderMutationHookResult = ReturnType<
  typeof useCreateCampOrderMutation
>;
export type CreateCampOrderMutationResult =
  Apollo.MutationResult<CreateCampOrderMutation>;
export type CreateCampOrderMutationOptions = Apollo.BaseMutationOptions<
  CreateCampOrderMutation,
  CreateCampOrderMutationVariables
>;
export const CreatePaypalOrderDocument = gql`
  mutation CreatePaypalOrder($bookingUuid: String!) {
    createPaypalOrder(bookingUuid: $bookingUuid) {
      orderId
      approveLink
    }
  }
`;
export type CreatePaypalOrderMutationFn = Apollo.MutationFunction<
  CreatePaypalOrderMutation,
  CreatePaypalOrderMutationVariables
>;

/**
 * __useCreatePaypalOrderMutation__
 *
 * To run a mutation, you first call `useCreatePaypalOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaypalOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaypalOrderMutation, { data, loading, error }] = useCreatePaypalOrderMutation({
 *   variables: {
 *      bookingUuid: // value for 'bookingUuid'
 *   },
 * });
 */
export function useCreatePaypalOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePaypalOrderMutation,
    CreatePaypalOrderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreatePaypalOrderMutation,
    CreatePaypalOrderMutationVariables
  >(CreatePaypalOrderDocument, options);
}
export type CreatePaypalOrderMutationHookResult = ReturnType<
  typeof useCreatePaypalOrderMutation
>;
export type CreatePaypalOrderMutationResult =
  Apollo.MutationResult<CreatePaypalOrderMutation>;
export type CreatePaypalOrderMutationOptions = Apollo.BaseMutationOptions<
  CreatePaypalOrderMutation,
  CreatePaypalOrderMutationVariables
>;
export const CreateRentalOrderDocument = gql`
  mutation CreateRentalOrder($rentalOrderData: RentalOrderInput!) {
    createRentalOrder(rentalOrderData: $rentalOrderData) {
      uuid
      totalETPrice
      totalVATPrice
      startDate
      endDate
      status
      productToOrders {
        uuid
        quantity
        dates {
          startDate
          endDate
        }
        product {
          uuid
          name
        }
        activatedOptions {
          uuid
          price
          name
        }
        totalPrice
      }
      booking {
        uuid
        numberOfAdults
        numberOfChildren
        VATPricePerLesson
        ETPricePerLesson
        totalETPrice
        totalVATPrice
        VATTotalIncrementPerHour
        totalETPriceWithoutDiscount
        totalVATPriceWithoutDiscount
        totalRentingETPrice
        totalRentingVATPrice
        totalLessonsVATPrice
        totalLessonsETPrice
        discountAmount
        discount {
          code
        }
      }
    }
  }
`;
export type CreateRentalOrderMutationFn = Apollo.MutationFunction<
  CreateRentalOrderMutation,
  CreateRentalOrderMutationVariables
>;

/**
 * __useCreateRentalOrderMutation__
 *
 * To run a mutation, you first call `useCreateRentalOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRentalOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRentalOrderMutation, { data, loading, error }] = useCreateRentalOrderMutation({
 *   variables: {
 *      rentalOrderData: // value for 'rentalOrderData'
 *   },
 * });
 */
export function useCreateRentalOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateRentalOrderMutation,
    CreateRentalOrderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateRentalOrderMutation,
    CreateRentalOrderMutationVariables
  >(CreateRentalOrderDocument, options);
}
export type CreateRentalOrderMutationHookResult = ReturnType<
  typeof useCreateRentalOrderMutation
>;
export type CreateRentalOrderMutationResult =
  Apollo.MutationResult<CreateRentalOrderMutation>;
export type CreateRentalOrderMutationOptions = Apollo.BaseMutationOptions<
  CreateRentalOrderMutation,
  CreateRentalOrderMutationVariables
>;
export const CreateReviewDocument = gql`
  mutation CreateReview(
    $rating: Float!
    $content: String!
    $bookingUuid: String!
    $userUuid: String!
  ) {
    createReview(
      rating: $rating
      content: $content
      bookingUuid: $bookingUuid
      userUuid: $userUuid
    ) {
      uuid
      rating
      content
    }
  }
`;
export type CreateReviewMutationFn = Apollo.MutationFunction<
  CreateReviewMutation,
  CreateReviewMutationVariables
>;

/**
 * __useCreateReviewMutation__
 *
 * To run a mutation, you first call `useCreateReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReviewMutation, { data, loading, error }] = useCreateReviewMutation({
 *   variables: {
 *      rating: // value for 'rating'
 *      content: // value for 'content'
 *      bookingUuid: // value for 'bookingUuid'
 *      userUuid: // value for 'userUuid'
 *   },
 * });
 */
export function useCreateReviewMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateReviewMutation,
    CreateReviewMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateReviewMutation,
    CreateReviewMutationVariables
  >(CreateReviewDocument, options);
}
export type CreateReviewMutationHookResult = ReturnType<
  typeof useCreateReviewMutation
>;
export type CreateReviewMutationResult =
  Apollo.MutationResult<CreateReviewMutation>;
export type CreateReviewMutationOptions = Apollo.BaseMutationOptions<
  CreateReviewMutation,
  CreateReviewMutationVariables
>;
export const CreateStripeOrderDocument = gql`
  mutation CreateStripeOrder($bookingUuid: String!) {
    createStripeOrder(bookingUuid: $bookingUuid)
  }
`;
export type CreateStripeOrderMutationFn = Apollo.MutationFunction<
  CreateStripeOrderMutation,
  CreateStripeOrderMutationVariables
>;

/**
 * __useCreateStripeOrderMutation__
 *
 * To run a mutation, you first call `useCreateStripeOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStripeOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStripeOrderMutation, { data, loading, error }] = useCreateStripeOrderMutation({
 *   variables: {
 *      bookingUuid: // value for 'bookingUuid'
 *   },
 * });
 */
export function useCreateStripeOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateStripeOrderMutation,
    CreateStripeOrderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateStripeOrderMutation,
    CreateStripeOrderMutationVariables
  >(CreateStripeOrderDocument, options);
}
export type CreateStripeOrderMutationHookResult = ReturnType<
  typeof useCreateStripeOrderMutation
>;
export type CreateStripeOrderMutationResult =
  Apollo.MutationResult<CreateStripeOrderMutation>;
export type CreateStripeOrderMutationOptions = Apollo.BaseMutationOptions<
  CreateStripeOrderMutation,
  CreateStripeOrderMutationVariables
>;
export const DeleteBookingDocument = gql`
  mutation DeleteBooking($bookingUuid: String!) {
    deleteBooking(bookingUuid: $bookingUuid)
  }
`;
export type DeleteBookingMutationFn = Apollo.MutationFunction<
  DeleteBookingMutation,
  DeleteBookingMutationVariables
>;

/**
 * __useDeleteBookingMutation__
 *
 * To run a mutation, you first call `useDeleteBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBookingMutation, { data, loading, error }] = useDeleteBookingMutation({
 *   variables: {
 *      bookingUuid: // value for 'bookingUuid'
 *   },
 * });
 */
export function useDeleteBookingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteBookingMutation,
    DeleteBookingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteBookingMutation,
    DeleteBookingMutationVariables
  >(DeleteBookingDocument, options);
}
export type DeleteBookingMutationHookResult = ReturnType<
  typeof useDeleteBookingMutation
>;
export type DeleteBookingMutationResult =
  Apollo.MutationResult<DeleteBookingMutation>;
export type DeleteBookingMutationOptions = Apollo.BaseMutationOptions<
  DeleteBookingMutation,
  DeleteBookingMutationVariables
>;
export const LoginClientDocument = gql`
  mutation LoginClient($idToken: String!) {
    loginClient(idToken: $idToken) {
      error {
        field
        message
      }
      user {
        uuid
        firstName
        lastName
        email
        picture
        registrationComplete
        client {
          sportType
          level
        }
        profile {
          language
        }
      }
    }
  }
`;
export type LoginClientMutationFn = Apollo.MutationFunction<
  LoginClientMutation,
  LoginClientMutationVariables
>;

/**
 * __useLoginClientMutation__
 *
 * To run a mutation, you first call `useLoginClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginClientMutation, { data, loading, error }] = useLoginClientMutation({
 *   variables: {
 *      idToken: // value for 'idToken'
 *   },
 * });
 */
export function useLoginClientMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LoginClientMutation,
    LoginClientMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<LoginClientMutation, LoginClientMutationVariables>(
    LoginClientDocument,
    options
  );
}
export type LoginClientMutationHookResult = ReturnType<
  typeof useLoginClientMutation
>;
export type LoginClientMutationResult =
  Apollo.MutationResult<LoginClientMutation>;
export type LoginClientMutationOptions = Apollo.BaseMutationOptions<
  LoginClientMutation,
  LoginClientMutationVariables
>;
export const RemoveDiscountDocument = gql`
  mutation RemoveDiscount($bookingUuid: String!) {
    removeDiscount(bookingUuid: $bookingUuid) {
      uuid
      VATPricePerLesson
      ETPricePerLesson
      totalETPrice
      totalVATPrice
      VATTotalIncrementPerHour
      totalETPriceWithoutDiscount
      totalVATPriceWithoutDiscount
      totalRentingETPrice
      totalRentingVATPrice
      totalLessonsVATPrice
      totalLessonsETPrice
      discountAmount
      discount {
        code
      }
    }
  }
`;
export type RemoveDiscountMutationFn = Apollo.MutationFunction<
  RemoveDiscountMutation,
  RemoveDiscountMutationVariables
>;

/**
 * __useRemoveDiscountMutation__
 *
 * To run a mutation, you first call `useRemoveDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDiscountMutation, { data, loading, error }] = useRemoveDiscountMutation({
 *   variables: {
 *      bookingUuid: // value for 'bookingUuid'
 *   },
 * });
 */
export function useRemoveDiscountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveDiscountMutation,
    RemoveDiscountMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveDiscountMutation,
    RemoveDiscountMutationVariables
  >(RemoveDiscountDocument, options);
}
export type RemoveDiscountMutationHookResult = ReturnType<
  typeof useRemoveDiscountMutation
>;
export type RemoveDiscountMutationResult =
  Apollo.MutationResult<RemoveDiscountMutation>;
export type RemoveDiscountMutationOptions = Apollo.BaseMutationOptions<
  RemoveDiscountMutation,
  RemoveDiscountMutationVariables
>;
export const UpdateCampOrderDocument = gql`
  mutation UpdateCampOrder(
    $packages: [PackageSelectionInput!]!
    $orderUuid: String!
  ) {
    updateCampOrder(packages: $packages, orderUuid: $orderUuid) {
      ETPrice
      VATPrice
    }
  }
`;
export type UpdateCampOrderMutationFn = Apollo.MutationFunction<
  UpdateCampOrderMutation,
  UpdateCampOrderMutationVariables
>;

/**
 * __useUpdateCampOrderMutation__
 *
 * To run a mutation, you first call `useUpdateCampOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampOrderMutation, { data, loading, error }] = useUpdateCampOrderMutation({
 *   variables: {
 *      packages: // value for 'packages'
 *      orderUuid: // value for 'orderUuid'
 *   },
 * });
 */
export function useUpdateCampOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCampOrderMutation,
    UpdateCampOrderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateCampOrderMutation,
    UpdateCampOrderMutationVariables
  >(UpdateCampOrderDocument, options);
}
export type UpdateCampOrderMutationHookResult = ReturnType<
  typeof useUpdateCampOrderMutation
>;
export type UpdateCampOrderMutationResult =
  Apollo.MutationResult<UpdateCampOrderMutation>;
export type UpdateCampOrderMutationOptions = Apollo.BaseMutationOptions<
  UpdateCampOrderMutation,
  UpdateCampOrderMutationVariables
>;
export const UpdateClientDocument = gql`
  mutation UpdateClient($sportType: [String!]!, $level: String!) {
    updateClient(clientData: { sportType: $sportType, level: $level }) {
      sportType
      level
    }
  }
`;
export type UpdateClientMutationFn = Apollo.MutationFunction<
  UpdateClientMutation,
  UpdateClientMutationVariables
>;

/**
 * __useUpdateClientMutation__
 *
 * To run a mutation, you first call `useUpdateClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientMutation, { data, loading, error }] = useUpdateClientMutation({
 *   variables: {
 *      sportType: // value for 'sportType'
 *      level: // value for 'level'
 *   },
 * });
 */
export function useUpdateClientMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateClientMutation,
    UpdateClientMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateClientMutation,
    UpdateClientMutationVariables
  >(UpdateClientDocument, options);
}
export type UpdateClientMutationHookResult = ReturnType<
  typeof useUpdateClientMutation
>;
export type UpdateClientMutationResult =
  Apollo.MutationResult<UpdateClientMutation>;
export type UpdateClientMutationOptions = Apollo.BaseMutationOptions<
  UpdateClientMutation,
  UpdateClientMutationVariables
>;
export const UpdateClientNameDocument = gql`
  mutation UpdateClientName($firstName: String!, $lastName: String!) {
    updateClientName(input: { firstName: $firstName, lastName: $lastName }) {
      firstName
      lastName
    }
  }
`;
export type UpdateClientNameMutationFn = Apollo.MutationFunction<
  UpdateClientNameMutation,
  UpdateClientNameMutationVariables
>;

/**
 * __useUpdateClientNameMutation__
 *
 * To run a mutation, you first call `useUpdateClientNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientNameMutation, { data, loading, error }] = useUpdateClientNameMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *   },
 * });
 */
export function useUpdateClientNameMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateClientNameMutation,
    UpdateClientNameMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateClientNameMutation,
    UpdateClientNameMutationVariables
  >(UpdateClientNameDocument, options);
}
export type UpdateClientNameMutationHookResult = ReturnType<
  typeof useUpdateClientNameMutation
>;
export type UpdateClientNameMutationResult =
  Apollo.MutationResult<UpdateClientNameMutation>;
export type UpdateClientNameMutationOptions = Apollo.BaseMutationOptions<
  UpdateClientNameMutation,
  UpdateClientNameMutationVariables
>;
export const UpdateProfileDocument = gql`
  mutation UpdateProfile($language: String!) {
    updateUserProfile(profileData: { language: $language }) {
      language
    }
  }
`;
export type UpdateProfileMutationFn = Apollo.MutationFunction<
  UpdateProfileMutation,
  UpdateProfileMutationVariables
>;

/**
 * __useUpdateProfileMutation__
 *
 * To run a mutation, you first call `useUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileMutation, { data, loading, error }] = useUpdateProfileMutation({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function useUpdateProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateProfileMutation,
    UpdateProfileMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateProfileMutation,
    UpdateProfileMutationVariables
  >(UpdateProfileDocument, options);
}
export type UpdateProfileMutationHookResult = ReturnType<
  typeof useUpdateProfileMutation
>;
export type UpdateProfileMutationResult =
  Apollo.MutationResult<UpdateProfileMutation>;
export type UpdateProfileMutationOptions = Apollo.BaseMutationOptions<
  UpdateProfileMutation,
  UpdateProfileMutationVariables
>;
export const UploadProfilePictureDocument = gql`
  mutation UploadProfilePicture($file: Upload!) {
    uploadProfilePicture(file: $file)
  }
`;
export type UploadProfilePictureMutationFn = Apollo.MutationFunction<
  UploadProfilePictureMutation,
  UploadProfilePictureMutationVariables
>;

/**
 * __useUploadProfilePictureMutation__
 *
 * To run a mutation, you first call `useUploadProfilePictureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadProfilePictureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadProfilePictureMutation, { data, loading, error }] = useUploadProfilePictureMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadProfilePictureMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadProfilePictureMutation,
    UploadProfilePictureMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UploadProfilePictureMutation,
    UploadProfilePictureMutationVariables
  >(UploadProfilePictureDocument, options);
}
export type UploadProfilePictureMutationHookResult = ReturnType<
  typeof useUploadProfilePictureMutation
>;
export type UploadProfilePictureMutationResult =
  Apollo.MutationResult<UploadProfilePictureMutation>;
export type UploadProfilePictureMutationOptions = Apollo.BaseMutationOptions<
  UploadProfilePictureMutation,
  UploadProfilePictureMutationVariables
>;
export const GetAvailableResortsDocument = gql`
  query GetAvailableResorts {
    getAvailableResorts {
      uuid
      name
      price
    }
  }
`;

/**
 * __useGetAvailableResortsQuery__
 *
 * To run a query within a React component, call `useGetAvailableResortsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableResortsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableResortsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailableResortsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAvailableResortsQuery,
    GetAvailableResortsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAvailableResortsQuery,
    GetAvailableResortsQueryVariables
  >(GetAvailableResortsDocument, options);
}
export function useGetAvailableResortsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAvailableResortsQuery,
    GetAvailableResortsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAvailableResortsQuery,
    GetAvailableResortsQueryVariables
  >(GetAvailableResortsDocument, options);
}
export type GetAvailableResortsQueryHookResult = ReturnType<
  typeof useGetAvailableResortsQuery
>;
export type GetAvailableResortsLazyQueryHookResult = ReturnType<
  typeof useGetAvailableResortsLazyQuery
>;
export type GetAvailableResortsQueryResult = Apollo.QueryResult<
  GetAvailableResortsQuery,
  GetAvailableResortsQueryVariables
>;
export const GetAvailableInstructorsDocument = gql`
  query GetAvailableInstructors(
    $resortUuid: String!
    $level: String!
    $sportType: String!
    $bookingDates: [BookingDate!]!
    $language: String!
    $numberOfChildren: Int!
    $numberOfAdults: Int!
  ) {
    getAvailableInstructors(
      queryInput: {
        resortUuid: $resortUuid
        level: $level
        sportType: $sportType
        bookingDates: $bookingDates
        language: $language
        numberOfChildren: $numberOfChildren
        numberOfAdults: $numberOfAdults
      }
    ) {
      instructor {
        uuid
        firstName
        lastName
        email
        picture
        instructor {
          bio
          minNumberOfHours
          rating
          targetedLevel
          spokenLanguages
        }
        profile {
          language
        }
      }
      availability {
        availableDays {
          date
          slot {
            startTime
            endTime
          }
        }
        points
      }
      price
    }
  }
`;

/**
 * __useGetAvailableInstructorsQuery__
 *
 * To run a query within a React component, call `useGetAvailableInstructorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableInstructorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableInstructorsQuery({
 *   variables: {
 *      resortUuid: // value for 'resortUuid'
 *      level: // value for 'level'
 *      sportType: // value for 'sportType'
 *      bookingDates: // value for 'bookingDates'
 *      language: // value for 'language'
 *      numberOfChildren: // value for 'numberOfChildren'
 *      numberOfAdults: // value for 'numberOfAdults'
 *   },
 * });
 */
export function useGetAvailableInstructorsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAvailableInstructorsQuery,
    GetAvailableInstructorsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAvailableInstructorsQuery,
    GetAvailableInstructorsQueryVariables
  >(GetAvailableInstructorsDocument, options);
}
export function useGetAvailableInstructorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAvailableInstructorsQuery,
    GetAvailableInstructorsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAvailableInstructorsQuery,
    GetAvailableInstructorsQueryVariables
  >(GetAvailableInstructorsDocument, options);
}
export type GetAvailableInstructorsQueryHookResult = ReturnType<
  typeof useGetAvailableInstructorsQuery
>;
export type GetAvailableInstructorsLazyQueryHookResult = ReturnType<
  typeof useGetAvailableInstructorsLazyQuery
>;
export type GetAvailableInstructorsQueryResult = Apollo.QueryResult<
  GetAvailableInstructorsQuery,
  GetAvailableInstructorsQueryVariables
>;
export const GetClientBookingDocument = gql`
  query GetClientBooking($bookingUuid: String!) {
    getClientBooking(bookingUuid: $bookingUuid) {
      uuid
      numberOfAdults
      numberOfChildren
      VATPricePerLesson
      ETPricePerLesson
      totalETPrice
      totalVATPrice
      VATTotalIncrementPerHour
      totalETPriceWithoutDiscount
      totalVATPriceWithoutDiscount
      totalRentingETPrice
      totalRentingVATPrice
      totalLessonsVATPrice
      totalLessonsETPrice
      discountAmount
      discount {
        code
      }
      instructor {
        firstName
        lastName
        email
      }
      lessons {
        lessonDate
        duration
        sport
        startTime
        status
        price
      }
      numberOfAdults
      numberOfChildren
      resort {
        uuid
        name
        price
      }
    }
  }
`;

/**
 * __useGetClientBookingQuery__
 *
 * To run a query within a React component, call `useGetClientBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientBookingQuery({
 *   variables: {
 *      bookingUuid: // value for 'bookingUuid'
 *   },
 * });
 */
export function useGetClientBookingQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetClientBookingQuery,
    GetClientBookingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetClientBookingQuery, GetClientBookingQueryVariables>(
    GetClientBookingDocument,
    options
  );
}
export function useGetClientBookingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetClientBookingQuery,
    GetClientBookingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetClientBookingQuery,
    GetClientBookingQueryVariables
  >(GetClientBookingDocument, options);
}
export type GetClientBookingQueryHookResult = ReturnType<
  typeof useGetClientBookingQuery
>;
export type GetClientBookingLazyQueryHookResult = ReturnType<
  typeof useGetClientBookingLazyQuery
>;
export type GetClientBookingQueryResult = Apollo.QueryResult<
  GetClientBookingQuery,
  GetClientBookingQueryVariables
>;
export const GetClientLessonsDocument = gql`
  query GetClientLessons {
    getClientLessons {
      uuid
      lessonDate
      startTime
      duration
      sport
      status
      numberOfAdults
      numberOfChildren
      price
      fullPrice
      instructor {
        uuid
        firstName
        lastName
        email
        picture
        instructor {
          bio
          rating
          targetedLevel
          spokenLanguages
        }
        profile {
          language
        }
      }
    }
  }
`;

/**
 * __useGetClientLessonsQuery__
 *
 * To run a query within a React component, call `useGetClientLessonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientLessonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientLessonsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClientLessonsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetClientLessonsQuery,
    GetClientLessonsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetClientLessonsQuery, GetClientLessonsQueryVariables>(
    GetClientLessonsDocument,
    options
  );
}
export function useGetClientLessonsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetClientLessonsQuery,
    GetClientLessonsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetClientLessonsQuery,
    GetClientLessonsQueryVariables
  >(GetClientLessonsDocument, options);
}
export type GetClientLessonsQueryHookResult = ReturnType<
  typeof useGetClientLessonsQuery
>;
export type GetClientLessonsLazyQueryHookResult = ReturnType<
  typeof useGetClientLessonsLazyQuery
>;
export type GetClientLessonsQueryResult = Apollo.QueryResult<
  GetClientLessonsQuery,
  GetClientLessonsQueryVariables
>;
export const GetClientRentalOrderDocument = gql`
  query GetClientRentalOrder($rentalOrderUuid: String!) {
    getClientRentalOrder(rentalOrderUuid: $rentalOrderUuid) {
      uuid
      totalETPrice
      totalVATPrice
      startDate
      endDate
      status
      productToOrders {
        uuid
        quantity
        dates {
          startDate
          endDate
        }
        product {
          uuid
          name
        }
        activatedOptions {
          uuid
          price
          name
        }
        totalPrice
      }
      booking {
        uuid
        numberOfAdults
        numberOfChildren
        VATPricePerLesson
        ETPricePerLesson
        totalETPrice
        totalVATPrice
        VATTotalIncrementPerHour
        totalETPriceWithoutDiscount
        totalVATPriceWithoutDiscount
        totalRentingETPrice
        totalRentingVATPrice
        totalLessonsVATPrice
        totalLessonsETPrice
        discountAmount
        discount {
          code
        }
      }
    }
  }
`;

/**
 * __useGetClientRentalOrderQuery__
 *
 * To run a query within a React component, call `useGetClientRentalOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientRentalOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientRentalOrderQuery({
 *   variables: {
 *      rentalOrderUuid: // value for 'rentalOrderUuid'
 *   },
 * });
 */
export function useGetClientRentalOrderQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetClientRentalOrderQuery,
    GetClientRentalOrderQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetClientRentalOrderQuery,
    GetClientRentalOrderQueryVariables
  >(GetClientRentalOrderDocument, options);
}
export function useGetClientRentalOrderLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetClientRentalOrderQuery,
    GetClientRentalOrderQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetClientRentalOrderQuery,
    GetClientRentalOrderQueryVariables
  >(GetClientRentalOrderDocument, options);
}
export type GetClientRentalOrderQueryHookResult = ReturnType<
  typeof useGetClientRentalOrderQuery
>;
export type GetClientRentalOrderLazyQueryHookResult = ReturnType<
  typeof useGetClientRentalOrderLazyQuery
>;
export type GetClientRentalOrderQueryResult = Apollo.QueryResult<
  GetClientRentalOrderQuery,
  GetClientRentalOrderQueryVariables
>;
export const GetClientRentalOrdersDocument = gql`
  query GetClientRentalOrders {
    getClientRentalOrders {
      uuid
      totalETPrice
      totalVATPrice
      startDate
      endDate
      status
      productToOrders {
        uuid
        quantity
        dates {
          startDate
          endDate
        }
        product {
          uuid
          name
        }
        activatedOptions {
          uuid
          price
          name
        }
        totalPrice
      }
      booking {
        uuid
        numberOfAdults
        numberOfChildren
        VATPricePerLesson
        ETPricePerLesson
        totalETPrice
        totalVATPrice
        VATTotalIncrementPerHour
        totalETPriceWithoutDiscount
        totalVATPriceWithoutDiscount
        totalRentingETPrice
        totalRentingVATPrice
        totalLessonsVATPrice
        totalLessonsETPrice
        discountAmount
        discount {
          code
        }
      }
      store {
        uuid
        name
        phone
        address
        resort {
          uuid
          name
        }
      }
    }
  }
`;

/**
 * __useGetClientRentalOrdersQuery__
 *
 * To run a query within a React component, call `useGetClientRentalOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientRentalOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientRentalOrdersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClientRentalOrdersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetClientRentalOrdersQuery,
    GetClientRentalOrdersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetClientRentalOrdersQuery,
    GetClientRentalOrdersQueryVariables
  >(GetClientRentalOrdersDocument, options);
}
export function useGetClientRentalOrdersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetClientRentalOrdersQuery,
    GetClientRentalOrdersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetClientRentalOrdersQuery,
    GetClientRentalOrdersQueryVariables
  >(GetClientRentalOrdersDocument, options);
}
export type GetClientRentalOrdersQueryHookResult = ReturnType<
  typeof useGetClientRentalOrdersQuery
>;
export type GetClientRentalOrdersLazyQueryHookResult = ReturnType<
  typeof useGetClientRentalOrdersLazyQuery
>;
export type GetClientRentalOrdersQueryResult = Apollo.QueryResult<
  GetClientRentalOrdersQuery,
  GetClientRentalOrdersQueryVariables
>;
export const GetDefaultPackagesListDocument = gql`
  query GetDefaultPackagesList {
    getDefaultPackagesList {
      uuid
      ETPrice
      VATPrice
      name
      description
      picture
    }
  }
`;

/**
 * __useGetDefaultPackagesListQuery__
 *
 * To run a query within a React component, call `useGetDefaultPackagesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDefaultPackagesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDefaultPackagesListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDefaultPackagesListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDefaultPackagesListQuery,
    GetDefaultPackagesListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDefaultPackagesListQuery,
    GetDefaultPackagesListQueryVariables
  >(GetDefaultPackagesListDocument, options);
}
export function useGetDefaultPackagesListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDefaultPackagesListQuery,
    GetDefaultPackagesListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDefaultPackagesListQuery,
    GetDefaultPackagesListQueryVariables
  >(GetDefaultPackagesListDocument, options);
}
export type GetDefaultPackagesListQueryHookResult = ReturnType<
  typeof useGetDefaultPackagesListQuery
>;
export type GetDefaultPackagesListLazyQueryHookResult = ReturnType<
  typeof useGetDefaultPackagesListLazyQuery
>;
export type GetDefaultPackagesListQueryResult = Apollo.QueryResult<
  GetDefaultPackagesListQuery,
  GetDefaultPackagesListQueryVariables
>;
export const GetStoresAndSortedProductsByResortDocument = gql`
  query GetStoresAndSortedProductsByResort($resortUuid: String!) {
    getStoresAndSortedProductsByResort(resortUuid: $resortUuid) {
      uuid
      name
      products {
        ADULT {
          uuid
          productUuid
          product {
            uuid
            name
            category
            description
            picture
            type
          }
          options {
            uuid
            name
            price
            product {
              name
            }
          }
          currentQuantity
          maxQuantity
          price
        }
        CHILDREN {
          uuid
          productUuid
          product {
            uuid
            name
            category
            description
            picture
            type
          }
          options {
            uuid
            name
            price
            product {
              name
            }
          }
          currentQuantity
          maxQuantity
          price
        }
        OTHER {
          uuid
          productUuid
          product {
            uuid
            name
            category
            description
            picture
            type
          }
          options {
            uuid
            name
            price
            product {
              name
            }
          }
          currentQuantity
          maxQuantity
          price
        }
      }
      phone
      address
      zipcode
      country {
        name
        uuid
      }
    }
  }
`;

/**
 * __useGetStoresAndSortedProductsByResortQuery__
 *
 * To run a query within a React component, call `useGetStoresAndSortedProductsByResortQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoresAndSortedProductsByResortQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoresAndSortedProductsByResortQuery({
 *   variables: {
 *      resortUuid: // value for 'resortUuid'
 *   },
 * });
 */
export function useGetStoresAndSortedProductsByResortQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetStoresAndSortedProductsByResortQuery,
    GetStoresAndSortedProductsByResortQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetStoresAndSortedProductsByResortQuery,
    GetStoresAndSortedProductsByResortQueryVariables
  >(GetStoresAndSortedProductsByResortDocument, options);
}
export function useGetStoresAndSortedProductsByResortLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetStoresAndSortedProductsByResortQuery,
    GetStoresAndSortedProductsByResortQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetStoresAndSortedProductsByResortQuery,
    GetStoresAndSortedProductsByResortQueryVariables
  >(GetStoresAndSortedProductsByResortDocument, options);
}
export type GetStoresAndSortedProductsByResortQueryHookResult = ReturnType<
  typeof useGetStoresAndSortedProductsByResortQuery
>;
export type GetStoresAndSortedProductsByResortLazyQueryHookResult = ReturnType<
  typeof useGetStoresAndSortedProductsByResortLazyQuery
>;
export type GetStoresAndSortedProductsByResortQueryResult = Apollo.QueryResult<
  GetStoresAndSortedProductsByResortQuery,
  GetStoresAndSortedProductsByResortQueryVariables
>;
export const GetUnratedBookingDocument = gql`
  query GetUnratedBooking {
    getUnratedBooking {
      uuid
      instructor {
        uuid
        firstName
        lastName
        picture
      }
    }
  }
`;

/**
 * __useGetUnratedBookingQuery__
 *
 * To run a query within a React component, call `useGetUnratedBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnratedBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnratedBookingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnratedBookingQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetUnratedBookingQuery,
    GetUnratedBookingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetUnratedBookingQuery,
    GetUnratedBookingQueryVariables
  >(GetUnratedBookingDocument, options);
}
export function useGetUnratedBookingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUnratedBookingQuery,
    GetUnratedBookingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetUnratedBookingQuery,
    GetUnratedBookingQueryVariables
  >(GetUnratedBookingDocument, options);
}
export type GetUnratedBookingQueryHookResult = ReturnType<
  typeof useGetUnratedBookingQuery
>;
export type GetUnratedBookingLazyQueryHookResult = ReturnType<
  typeof useGetUnratedBookingLazyQuery
>;
export type GetUnratedBookingQueryResult = Apollo.QueryResult<
  GetUnratedBookingQuery,
  GetUnratedBookingQueryVariables
>;
export const GetUserReviewsDocument = gql`
  query GetUserReviews($userUuid: String!) {
    getUserReviews(userUuid: $userUuid) {
      uuid
      rating
      content
      reviewer {
        uuid
        firstName
        lastName
        picture
      }
      createdAt
    }
  }
`;

/**
 * __useGetUserReviewsQuery__
 *
 * To run a query within a React component, call `useGetUserReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserReviewsQuery({
 *   variables: {
 *      userUuid: // value for 'userUuid'
 *   },
 * });
 */
export function useGetUserReviewsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetUserReviewsQuery,
    GetUserReviewsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserReviewsQuery, GetUserReviewsQueryVariables>(
    GetUserReviewsDocument,
    options
  );
}
export function useGetUserReviewsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserReviewsQuery,
    GetUserReviewsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUserReviewsQuery, GetUserReviewsQueryVariables>(
    GetUserReviewsDocument,
    options
  );
}
export type GetUserReviewsQueryHookResult = ReturnType<
  typeof useGetUserReviewsQuery
>;
export type GetUserReviewsLazyQueryHookResult = ReturnType<
  typeof useGetUserReviewsLazyQuery
>;
export type GetUserReviewsQueryResult = Apollo.QueryResult<
  GetUserReviewsQuery,
  GetUserReviewsQueryVariables
>;
